module.exports = __webpack_public_path__ + "img/mbanner1.2e6f31ca.jpg";